<template>
    <div class="main liberacao-periodos">
        <c-panel title="Liberação do lançamento" titleIcon="fas fa-lock-open">
            
            <div v-if="carregando" class="u-text-center" style="min-height: 90px;">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <table v-else class="table table-striped lp-tabela">
                <thead>
                    <tr>
                        <th>Período letivo</th>
                        <th class="u-text-center">Situação</th>
                        <th>Última alteração</th>
                        <th class="u-text-right">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="!periodos.length">
                        <td colspan="4" class="u-text-center">Nenhum período letivo cadastrado.</td>
                    </tr>
                    <tr v-for="p in periodos" :key="p.id">
                        <td><b>{{ p.nome }}</b></td>
                        <td class="u-text-center">
                            <el-tag v-if="p.lancamento_liberado" type="success" size="small">Liberado</el-tag>
                            <el-tag v-else type="info" size="small">Bloqueado</el-tag>
                        </td>
                        <td class="lp-alteracao">
                            <template v-if="p.alterado_em">{{ p.alterado_por || '—' }} em {{ $moment(p.alterado_em).format('DD/MM/YYYY HH:mm') }}</template>
                            <template v-else>—</template>
                        </td>
                        <td class="u-text-right">
                            <el-button v-if="p.lancamento_liberado" size="mini" type="danger" plain :loading="salvando == p.id" @click="alterar(p, false)">Bloquear lançamento</el-button>
                            <el-button v-else size="mini" type="primary" :loading="salvando == p.id" @click="alterar(p, true)">Liberar lançamento</el-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </c-panel>
    </div>
</template>

<script>
// Diário › Parâmetros nos modos de frequência por período / notas por média do bimestre:
// a liberação do lançamento é global, por ano letivo (periodos_letivos.lancamento_liberado).
export default {
    data () {
        return { carregando: false, salvando: null, periodos: [] }
    },
    mounted () {
        this.carregar()
    },
    methods: {
        async carregar () {
            this.carregando = true
            try {
                const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/diario/getPeriodosLancamento`, this.$store.getters.getHeaderAuth)
                this.periodos = (res.data && res.data.periodos) || []
            } catch (e) {
                this.$store.commit('throwException', e)
            } finally {
                this.carregando = false
            }
        },
        async alterar (periodo, liberado) {
            const texto = liberado
                ? `Liberar o lançamento de notas, pareceres e frequência de ${periodo.nome} para todas as instituições?`
                : `Bloquear o lançamento de ${periodo.nome}? As telas de lançamento ficarão só para consulta em todas as instituições.`
            try {
                await this.$confirm(texto, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
            } catch (e) {
                return
            }

            this.salvando = periodo.id
            try {
                const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/liberarLancamento/${periodo.id}`, { liberado }, this.$store.getters.getHeaderAuth)
                if (res.data && res.data.erro) {
                    window.eventBus.$emit('alert', { msg: res.data.erro.text || res.data.erro, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: res.data.mensagem, type: 'success' })
                await this.carregar()
            } catch (e) {
                this.$store.commit('throwException', e)
            } finally {
                this.salvando = null
            }
        }
    }
}
</script>

<style>
    .liberacao-periodos .lp-ajuda {
        color: #606266;
        margin-bottom: 15px;
    }
    .liberacao-periodos .lp-alteracao {
        color: #909399;
        font-size: 12px;
    }
</style>
